export default {
  state: {
    consolidationData: {},
    formulasConsolidationData: {},
    lubricantConsolidationData: {},
  },

  getters: {
    getConsolidationData(state) {
      return state.consolidationData;
    },

    getFormulasConsolidationData(state) {
      return state.formulasConsolidationData;
    },

    getLubricantConsolidationData(state) {
      return state.lubricantConsolidationData;
    }
  },

  mutations: {
    setConsolidationData(state, data) {
      const isNull = data === null;

      state.consolidationData = {
        competence: !isNull ? data.competence : "",
        region: !isNull ? data.region : "",
        qtSolicitations: !isNull ? data.qtSolicitations : 0,
        qtSolicitationsAuthorized: !isNull ? data.qtSolicitationsAuthorized : 0,
        qtSolicitationsInternal: !isNull ? data.qtSolicitationsInternal : 0,
        qtSolicitationsExternal: !isNull ? data.qtSolicitationsExternal : 0,
        qtSolicitationsTextured: !isNull ? data.qtSolicitationsTextured : 0,
        qtSolicitationsSensitive: !isNull ? data.qtSolicitationsSensitive : 0,
      }
    },

    setFormulasConsolidationData(state, data) {
      const isNull = data === null;

      state.formulasConsolidationData = {
        competence: !isNull ? data.competence : "",
        region: !isNull ? data.region : "",
        qtSolicitations: !isNull ? data.qtSolicitations : 0,
        qtSolicitationsAuthorized: !isNull ? data.qtSolicitationsAuthorized : 0,
        qtSolicitationsF1: !isNull ? data.qtSolicitationsF1 : 0,
        qtSolicitationsF2: !isNull ? data.qtSolicitationsF2 : 0,
      }
    },

    setLubricantConsolidationData(state, data) {
      const isNull = data === null;

      console.log(data);
      state.lubricantConsolidationData = {
        competence: !isNull ? data.competence : "",
        region: !isNull ? data.region : "",
        qtSolicitations: !isNull ? data.qtSolicitations : 0,
        qtSolicitationsAuthorized: !isNull ? data.qtSolicitationsAuthorized : 0,
        qtSolicitationsLubricant: !isNull ? data.qtSolicitationsLubricant : 0,
      }
    }
  },

  actions: {
    changeConsolidationData(context, infos) {
      context.commit("setConsolidationData", infos);
    },

    changeFormulasConsolidationData(context, infos) {
      context.commit("setFormulasConsolidationData", infos);
    },

    changeLubricantConsolidationData(context, infos) {
      context.commit("setLubricantConsolidationData", infos);
    }
  }
}